import Text from "common/Typography/Text";
import React, { useMemo } from "react";
import { useTheme } from "styled-components";
import styled from "styled-components";
import IconWithFallback from "Global/IconWithFallback";
import { Market } from "types";
import WatchlistPrice from "features/watchlist/common/WatchlistPrice";
import { ICON_TYPES } from "@shared/common/constants";
import LivePriceChange from "common/LiveComponents/LivePriceChange";
import { getCoinExtraDetailsRoute } from "utils/routes";
import { useLocation } from "react-router-dom";
import useHistoryWithQuery from "utils/hooks/useHistoryWithQuery";
import Tooltip from "common/Tooltips/Tooltip";
import {
  SYMBOL_FONT_SIZE,
  SYMBOL_FONT_WEIGHT,
  SYMBOL_HORIZONTAL_MARGIN,
  SYMBOL_ICON_MARGIN,
  SYMBOL_ICON_SIZE,
} from "features/watchlist/TopSymbols/constants.ts";

interface TopSymbolsProps {
  market: Market;
  symbolFontSize?: number;
  symbolFontWeight?: number;
}

const TopSymbol: React.FC<TopSymbolsProps> = ({ market }) => {
  const appTheme = useTheme();
  const { symbol, exchange } = market;
  const location = useLocation();
  const { historyPush } = useHistoryWithQuery();

  const openCoinExtraDetailsDrawer = () => {
    historyPush(getCoinExtraDetailsRoute(location.pathname, symbol));
  };

  const watchlistPriceStyle = useMemo(() => {
    return {
      fontWeight: appTheme.typography.fontWeights.SEMI_BOLD,
      margin: "3px 0 1px 0",
    };
  }, [appTheme]);

  return (
    <Tooltip
      title={exchange}
      styles={{ root: { fontSize: appTheme.typography.fontSizes.S } }}
    >
      <Wrapper onClick={openCoinExtraDetailsDrawer}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconWithFallback
            coinOrExchangeName={symbol}
            iconStyle={{
              marginRight: SYMBOL_ICON_MARGIN,
              width: SYMBOL_ICON_SIZE,
              height: SYMBOL_ICON_SIZE,
            }}
            iconType={ICON_TYPES.COIN}
          />
          <Text
            type="secondary"
            style={{
              fontSize: SYMBOL_FONT_SIZE,
              fontWeight: SYMBOL_FONT_WEIGHT,
            }}
          >
            {symbol}
          </Text>
        </div>
        <div style={{ width: "fit-content" }}>
          <WatchlistPrice
            market={market}
            fontSize={appTheme.typography.fontSizes.S}
            textColor={appTheme.colors.primaryText}
            style={watchlistPriceStyle}
          />
        </div>
        <LivePriceChange
          symbol={symbol}
          exchange={exchange}
          initialChange={market.graph_data.change}
          size={appTheme.typography.pxFontSizes.XS}
        />
      </Wrapper>
    </Tooltip>
  );
};

export default TopSymbol;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 ${SYMBOL_HORIZONTAL_MARGIN}px;
  cursor: pointer;
  max-width: 148px;
`;
